var _path, _path2, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6332 20.7751H5.5602C3.34272 20.7751 1.5374 18.9697 1.5374 16.7523C1.5374 14.5348 3.34272 12.7295 5.5602 12.7295H9.04989C9.19772 12.7295 9.31868 12.6085 9.31868 12.4607C9.31868 12.3128 9.19772 12.1919 9.04989 12.1919H5.5602C3.04709 12.1919 1 14.2391 1 16.7521C1 19.2651 3.04721 21.3123 5.5602 21.3123H17.6287C17.7765 21.3123 17.8975 21.1913 17.8975 21.0435C17.8975 20.8957 17.781 20.7747 17.6332 20.7747L17.6332 20.7751Z",
    fill: "black",
    stroke: "#DDDEE0",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37035 4.14612H18.4389C20.6563 4.14612 22.4617 5.95145 22.4617 8.16892C22.4617 10.3864 20.6563 12.1917 18.4389 12.1917H14.976C14.8282 12.1917 14.7072 12.3127 14.7072 12.4605C14.7072 12.6083 14.8282 12.7293 14.976 12.7293H18.4389C20.952 12.7293 22.9991 10.6821 22.9991 8.16908C22.9991 5.65147 20.9518 3.60889 18.4389 3.60889H6.37035C6.22251 3.60889 6.10156 3.72984 6.10156 3.87767C6.10156 4.0255 6.21804 4.14645 6.37035 4.14645V4.14612Z",
    fill: "black",
    stroke: "#DDDEE0",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.75,
    cy: 3.75,
    r: 2.15,
    stroke: "#DDDEE0",
    strokeWidth: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.25,
    cy: 20.7085,
    r: 2.15,
    stroke: "#DDDEE0",
    strokeWidth: 1.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.4585,
    r: 2.15,
    stroke: "#DDDEE0",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.8b620139ce1ffdc8d509279d9811bbcd.svg";
export { ForwardRef as ReactComponent };